/*
 * Modules in the canvas initially load their data from the Pinia store, and when the store updates
 * (either from another user's changes during collaborative editing, or from someplace else in the
 * app), these updates need to trickle down. While editing, though, the Pinia store shouldn't
 * be directly updated with each keypress. This allows modules to keep a local version of their
 * data that they can update, and choose when to dispatch an action to make a PATCH/update Pinia.
 */

import { cloneDeep } from 'lodash-es';
import { mapState } from 'pinia';
import {
  useEditorStore,
} from '@/stores';

export default {
  data() {
    return {
      clonedModuleData: null, // this.clonedModuleData is the local version for modules to edit
    };
  },
  computed: {
    ...mapState(useEditorStore, [
      'getModuleById',
    ]),
    storeModuleData() {
      // Always make a clone when reading from the store to avoid accidentally making
      // a direct edit
      return cloneDeep(this.getModuleById(this.id));
    },
  },
  watch: {
    storeModuleData() {
      // When data changes in the store, refresh the local module data,
      // unless doing so would overwrite invalid local data that hasn't been saved yet
      if (!this.validationError) {
        this.clonedModuleData = this.storeModuleData;
      }
    },
  },
  created() {
    // Initialize with data from the Pinia store
    this.clonedModuleData = this.storeModuleData;
  },
};
